<template>
  <div>
    <div class="toph mb16" >
      <span>续约意向</span>
      <div style="display: flex; align-items: center">
        <Select v-model="searchData.leaseTime" style="width: 85px" placeholder="租约类型" @on-change="change4Type">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in leaseTimeList" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
        </Select>
        <Select v-model="searchData.participateAct" style="width: 85px" placeholder="参与活动" @on-change="change4Type" v-if="isActivity === 1">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in participateActList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
        </Select>
        <div style="display: inline-block;width: 200px;">
          <DatePicker
            style="display: block"
            v-model="dueDay"
            placement="bottom-end"
            split-panels type="daterange"
            format="yyyy-MM-dd" @on-change="changeDueDay"
            placeholder="到期日"></DatePicker>
        </div>

        <Input style="display: inline-block;width: 260px;" type="text" v-model="searchData.cusPhoneNumber" placeholder="房间/床位号、签约客户、合同号、签约手机号" @keyup.enter.native="inputChange"></Input>
        <label @click.stop="inputChange" style="display: flex; margin-left: 5px">
          <Icon type="ios-search" size="24" color="#CFA868"/>
        </label>
      </div>

    </div>
    <div>
      <Tabs v-model="shortCut1" class="toph-tabs">
        <TabPane :label="'待确认'+' '+dqrNum" name="dqr"></TabPane>
        <TabPane :label="'租客未确定'+' '+wqdNum" name="wqd"></TabPane>
        <TabPane :label="'确定不续约'+' '+bxyNum" name="bxy"></TabPane>
        <TabPane :label="'确定续约'+' '+xyNum" name="xy"></TabPane>
      </Tabs>

      <table-list
        title="" :columns="columns" :data="data"
        :loading="loading" :total="total"
        :current="current" @change-page="changePage"
        :defaultTem="isShow"
        :pageSize="5"
      >
      </table-list>
      <read-modal :n="readKey" :contractId="contractId"></read-modal>
      <update-modal :n="updateKey" :status ="status" :contractFid="contractId" :subContractNum="subContractNum" @refresh="findData"></update-modal>
    </div>

  </div>
</template>

<script>
  import TableList from 'components/TableList/index'
  import {getRenewIntentionList, getRenewIntentionNum,getRenewIntentionCondition, getRenewIntentionActivityCondition, sendPreferentialMsg, previewCollageMsg, getGroupCount } from 'api/renewalIntention'
  import { findChildContractCountByParentFid } from 'api/workBench'
  import {formatDateTime} from "@//utils/format"
  import ReadModal from "./components/ReadModal"
  import UpdateModal from "./components/UpdateModal"

  export default {
    name: "Renew",
    components: {
      TableList,
      ReadModal,
      UpdateModal,
      getRenewIntentionList
    },
    watch:{
      projectFid(){
        this.recordCut = ''
        this.dueDay = []
        this.searchData.cusPhoneNumber = ''
        this.searchData.expireStartDate = ''
        this.searchData.expireEndDate = ''
        this.page=1
        this.current=1
        this.getRenewNum()
        this.getGroupCount()
      },
      shortCut1(value) {
        switch (value) {
          case 'dqr':
            this.clearValue()
            this.renewAgreementState = 0;
            break;
          case 'wqd':
            this.clearValue()
            this.renewAgreementState = 1;
            break;
          case "bxy":
            this.clearValue()
            this.renewAgreementState = 2;
            break;
          case 'xy':
            this.clearValue()
            this.renewAgreementState = 3;
            break;
        }
        this.page=1
        this.current=1
        this.getpageList();
      }
    },
    computed:{
      othersColumns(){
        if(this.shortCut1=='wqd' || this.shortCut1=='bxy'|| this.shortCut1=='xy'){
          return [{
            title: '最新跟进内容',
            key: 'remark',
            width:150,
            align: 'center',
            render: (h, params) => {
              if (params.row['remark'] && params.row['remark'].length > 7) {
                return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row['remark']),
                  h('span', {}, params.row['remark'].slice(0, 7) + '...')
                ])

              }
              else {
                return h('span', {}, params.row['remark'])
              }
            }
          },{
            title:' ',
          },
          {
            title: '最新跟进时间',
            key: 'operationTime',
            align: 'center',
            width:180,
            render: (h,params) => {
              return h('div',formatDateTime(params.row.operationTime, true).slice(0, 16))
            }
          },{
            title:' ',
          }]
        }
        else {
          return []
        }
      },
      activityColumns(){
        if(this.isActivity === 1) {
          return[{
            title: '参与活动',
            key: 'participateAct',
            align: 'center',
            width:180,
            render: (h,params) => {
              return h('div',params.row.participateAct === 2 ? '拼团续' : '--')
            }
          },{
            title:' ',
          }]
        }
        else {
          return []
        }
      },
      columns(){
        return [

          {
            type: "index",
            key: "index",
            width: 60,
            align: "center"
          },
          {
            title:' ',
          },
          {
            title:'房间/床位号',
            key:'stockNumber',
            align:'center',
            width:120
          },
          {
            title:' ',
          },
          {
            title: '剩余天数',
            key: 'surplusDays',
            align: 'center',
            width:120
          },
          {
            title:' ',
          },
          ...this.activityColumns,
          ...this.othersColumns,
          {
            title: '签约客户',
            key: 'customerName',
            align: 'center',
            width:220
          },
          {
            title:' ',
          },
          {
            title: '签约手机号',
            key: 'userPhone',
            align: 'center',
            width:120
          },
          {
            title:' ',
          },
          {
            title: '租约类型',
            key: 'rentTypeName',
            align: 'center',
            width:100
          },
          {
            title:' ',
          },
          {
            title: '签约ZO',
            key: 'handleZo',
            align: 'center',
            width:100
          },
          {
            title:' ',
          },
          {
            title: '起租日',
            key: 'conStartDate',
            align: 'center',
            width:120,
            render: (h,params) => {
              return h('div',formatDateTime(params.row.conStartDate,false))
            }
          },
          {
            title:' ',
          },
          {
            title: '到期日',
            key: 'conEndDate',
            align: 'center',
            width:120,
            render: (h,params) => {
              return h('div',formatDateTime(params.row.conEndDate,false))
            }
          },
          {
            title:' ',
          },{
            title:'操作',
            key:'action',
            align:'center',
            fixed:'right',
            width:150,
            render: (h,params) =>{
              return h('div',[h('a',{
                style: {
                  marginRight: '5px',
                },
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'renewagreement/agreementList'
                    }
                  }
                ],
                on:{
                  click: () => {
                    this.contractId = params.row.fid
                    this.readKey++
                  }
                }
              },'查看'),
                h('a',{
                  style: {
                    marginRight: '5px',
                  },
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'renewagreement/saveFollowAgreement'
                      }
                    }
                  ],
                  on:{
                    click: () => {
                      this.contractId = params.row.fid
                      this.status = params.row.renewAgreement

                      if(this.shortCut1 === 'dqr'){
                        this.recordCut = 'dqr'
                      }else if(this.shortCut1 === 'wqd'){
                        this.recordCut = 'wqd'
                      }else if(this.shortCut1 === 'bxy'){
                        this.recordCut = 'bxy'
                      }else if(this.shortCut1 === 'xy'){
                        this.recordCut = 'xy'
                      }
                      this.getSubContractNum(params.row.parentContractFid)
                    }
                  }
                },'跟进'),
                h('a',{
                style: {
                  marginRight: '5px',
                  display: (this.isActivity === 1) ? "inline-block" : "none"
                },
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'renewagreement/agreementList'
                    }
                  }
                ],
                on:{
                  click: () => {
                    const searchParams = {
                      projectId: this.projectFid,
                      phone: params.row.userPhone
                    }
                    this.preSendPreferentialMsg(searchParams)
                  }
                }
              },'发送拼团优惠')
              ])
            }
          }
        ]
      }
    },
    props: {
      projectFid: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        shortCut1: 'dqr',
        isActivity: 0,
        recordCut:'',
        page: 1,
        limit: 5,
        renewAgreementState:0,
        searchData: {
          cusPhoneNumber:'',
          expireStartDate:'',
          expireEndDate:'',
          leaseTime:'',
          participateAct: ''
        },
        dueDay:[],
        readKey:0,
        updateKey:0,
        subContractNum:0,
        status:null,
        contractId:'',
        dqrNum: 0,
        wqdNum: 0,
        bxyNum: 0,
        xyNum: 0,
        data:[],
        total:0,
        loading:false,
        current: 1,
        isShow:false,
        leaseTimeList: [],
        participateActList: []
      }
    },
    methods: {
      changeDueDay(val){
        this.searchData.expireStartDate = val[0]
        this.searchData.expireEndDate = val[1]
        this.current=1
        this.page=1
        this.data=[]

        if(this.shortCut1 === 'dqr'){
          this.recordCut = 'dqr'
        }else if(this.shortCut1 === 'wqd'){
          this.recordCut = 'wqd'
        }else if(this.shortCut1 === 'bxy'){
          this.recordCut = 'bxy'
        }else if(this.shortCut1 === 'xy'){
          this.recordCut = 'xy'
        }

        this.getRenewNum()
      },
      change4Type(val) {
        this.conType = val
        this.getRenewNum()
      },
      changePage(n) {
        this.current = n
        this.page = n
        this.getpageList()
      },
      findData(){
        if (this.data.length === 1) {
          this.current=1
          this.page=1
        }
        this.getRenewNum()
        this.$emit('refreshTotalNum')
      },
      getpageList() {
        if(!this.projectFid){
          return
        }
        const params={
          projectFid:this.projectFid,
          page:this.page,
          limit: 5,
          renewAgreementState:this.renewAgreementState,
          ...this.searchData
        }
        getRenewIntentionList(params).then(res => {
          if(!res.data){
            return
          }
          this.data = res.data.rows
          if(this.data.length<=0 ) {
            this.isShow = true;
          }
          this.total = res.data.total
        }).catch(error=>{})
      },
      getRenewNum() {
        if(!this.projectFid){
          return
        }

        const params={
          projectFid:this.projectFid,
          ...this.searchData
        }
        getRenewIntentionNum(params).then(res => {
          if(!res.data){
            return
          }
          res.data.forEach((ele)=>{
            if(ele.agreementState == 0){
              this.dqrNum = ele.number
            }else if (ele.agreementState == 1){
              this.wqdNum = ele.number
            }else if (ele.agreementState == 2){
              this.bxyNum = ele.number
            }else if (ele.agreementState == 3){
              this.xyNum = ele.number
            }
          })

          this.locationTab()
          this.getpageList()
        }).catch(error => {
        })
        getRenewIntentionCondition(params).then(res => {
          this.leaseTimeList = res.data
        }).catch(error=>{})

        getRenewIntentionActivityCondition(params).then(res => {
          this.participateActList = res.data
        }).catch(error => {})
      },
      clearValue() {
        this.page = 1
        this.limit = 5
      },
      inputChange(){
        this.current=1
        this.page=1
        this.data=[]

        if(this.shortCut1 === 'dqr'){
          this.recordCut = 'dqr'
        }else if(this.shortCut1 === 'wqd'){
          this.recordCut = 'wqd'
        }else if(this.shortCut1 === 'bxy'){
          this.recordCut = 'bxy'
        }else if(this.shortCut1 === 'xy'){
          this.recordCut = 'xy'
        }

        this.getRenewNum()
      },
      locationTab() {
        if(this.recordCut === 'dqr'){
          this.shortCut1='dqr'
          this.renewAgreementState = 0;
          return
        }else if(this.recordCut === 'wqd'){
          this.shortCut1='wqd'
          this.renewAgreementState = 1;
          return
        }else if(this.recordCut === 'bxy'){
          this.shortCut1='bxy'
          this.renewAgreementState = 2;
          return
        }else if(this.recordCut === 'xy'){
          this.shortCut1='xy'
          this.renewAgreementState = 3;
          return
        }

        if(this.dqrNum){
          this.shortCut1='dqr'
          this.renewAgreementState = 0;
        }else if(this.wqdNum){
          this.shortCut1='wqd'
          this.renewAgreementState = 1;
        }else if(this.bxyNum){
          this.shortCut1='bxy'
          this.renewAgreementState = 2;
        }else if(this.xyNum){
          this.shortCut1='xy'
          this.renewAgreementState = 3;
        }else {
          this.shortCut1='dqr'
          this.renewAgreementState = 0;
        }
      },
      preSendPreferentialMsg(params){
        let contentStr = ""
        previewCollageMsg(params).then(res => {
          if(res.code === 0){
            contentStr = res.data
            console.log(contentStr)
            this.sendMsg(contentStr, params)
          }
        })
      },
      sendMsg(contentStr, params){
        this.$Modal.confirm({
        title: '请确认短信文案',
        content: contentStr,
        width: 600,
        okText: '确认发送',
        onOk: () => {
          sendPreferentialMsg(params).then(res => {
          if(res.code === 0){
            this.$Message.success('已成功发送优惠短信')
          }
        })
        }
      })
      },
      getGroupCount(){
        getGroupCount(this.projectFid).then(res => {
          this.isActivity = res.data
        })
      },
      getSubContractNum(parentContractFid) {
        if(!parentContractFid){
          this.subContractNum = 0
        }else {
          const params={
            parentContractFid:parentContractFid
          }
          findChildContractCountByParentFid(params).then(res => {
            res.data && (this.subContractNum = res.data)
          }).catch(error=>{})
        }
        this.updateKey++
      },
      initData(){
        this.getRenewNum()
      }
    },
    created() {
      this.initData()
      this.getGroupCount()
    }
  }
</script>

<style scoped>
  .topitem{
    width: 150px;
    text-align: center;
    line-height: 2.2;


  }
  .activeitem{
    color: #CFA868;
  }
  .itemwrapper{
    border-bottom: 1px solid #f9f9f9;

  }
  .toph{
    display: flex;
    background-color: #F4F4F4 ;
    box-shadow: 0 1px 0 0 #F4F4F4;
    justify-content: space-between;
    align-items: center;
    padding:0  20px ;
    box-sizing: border-box;
    line-height: 40px;
  }

</style>
